import React, { useState } from 'react'
import moment from 'moment'
import { MenuItem, Select } from '@mui/material'
import { useLoad } from '../../../shared/hooks/requests'
import { GET_ATTENDANCE_HISTORY } from '../../../shared/utils/urls'

const years = [
    {
        value: '2024',
        label: '2024',
    },
    {
        value: '2025',
        label: '2025',
    },
]

const months = [
    {
        value: '09',
        label: 'September',
    },
    {
        value: '10',
        label: 'October',
    },
    {
        value: '11',
        label: 'November',
    },
    {
        value: '12',
        label: 'December',
    },
    {
        value: '01',
        label: 'January',
    },
    {
        value: '02',
        label: 'February',
    },
    {
        value: '03',
        label: 'March',
    },
    {
        value: '04',
        label: 'April',
    },
    {
        value: '05',
        label: 'May',
    },
    {
        value: '06',
        label: 'June',
    },
    {
        value: '07',
        label: 'July',
    },
    {
        value: '08',
        label: 'August',
    },
]

const cols = [
    { id: 1, title: 'ID' },
    { id: 2, title: 'Photo' },
    { id: 3, title: 'CreatedAt' },
    { id: 4, title: 'Attendance Datetime' },
]

const getStartAndEndDate = (year, month) => {
    const formattedMonth = month.padStart(2, '0') // Ensure MM format
    const startDate = `${year}-${formattedMonth}-01`
    const endDate = moment(startDate).add(1, 'month').format('YYYY-MM-DD')
    return { startDate, endDate }
}

export function AttendanceHistory({ id }) {
    const [historyDate, setHistoryDate] = useState({
        year: moment().format('YYYY'), // Get current year (e.g., 2024)
        month: moment().format('MM'), // Get current month (e.g., 03 for March)
    })
    const { startDate, endDate } = getStartAndEndDate(historyDate.year, historyDate.month)

    const getAttendanceHistory = useLoad({ url: GET_ATTENDANCE_HISTORY,
        params: { identity_id: id,
            start_date: startDate,
            end_date: endDate } }, [id, historyDate])
    const history = getAttendanceHistory.response ? getAttendanceHistory.response : []

    return (
        <div className="w-[100%] flex flex-col items-center gap-[10px]">
            <div className="w-[100%] flex py-[5px] px-[10px] items-center gap-[15px]">
                <Select
                    variant="outlined"
                    displayEmpty
                    renderValue={(value) => (value ? years.find((v) => v.value === value)?.label : 'Choose year')}
                    sx={{ height: 37, width: '10rem' }}
                    value={historyDate.year}
                    onChange={(e) => {
                        e.stopPropagation()
                        setHistoryDate({ year: e.target.value, month: historyDate.month })
                    }}
                >
                    {years.map((menuItem) => (
                        <MenuItem key={menuItem.value} value={menuItem.value}>
                            {menuItem?.label}
                        </MenuItem>
                    ))}
                </Select>

                <Select
                    variant="outlined"
                    displayEmpty
                    renderValue={(value) => (value ? months.find((v) => v.value === value)?.label : 'Choose month')}
                    sx={{ height: 37, width: '10rem' }}
                    value={historyDate.month}
                    onChange={(e) => {
                        e.stopPropagation()
                        setHistoryDate({ year: historyDate.year, month: e.target.value })
                    }}
                >
                    {months.map((menuItem) => (
                        <MenuItem key={menuItem.value} value={menuItem.value}>
                            {menuItem?.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div className="w-full flex flex-col items-center gap-[5px]">
                {/* Table Headers */}
                <div className="flex items-center justify-between w-full py-[6px] border-b pb-[6px]">
                    {cols.map((item) => (
                        <div key={item.id} className="w-[20%] flex items-center justify-center">
                            <span className="text-[14px] font-[400] text-black">
                                {item.title}
                            </span>
                        </div>
                    ))}
                </div>

                {/* Table Data */}
                <div className="w-full max-h-[450px] overflow-auto">
                    {history?.map((item) => (
                        <div
                            key={item.id}
                            className="w-full flex items-center py-[6px]
                         pr-[4px] border-b justify-between"
                        >
                            <div className="w-[20%] flex items-center justify-center">
                                <span className="text-[16px] font-[400] text-black">{item.id}</span>
                            </div>
                            <div className="w-[20%] flex items-center justify-center">
                                <div className="w-[50px] h-[50px] overflow-hidden">
                                    <img
                                        src={item.snapshotUrl}
                                        alt="img"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                            <div className="w-[20%] flex items-center justify-center">
                                <span className="text-[16px] font-[400] text-black">
                                    {moment(item.createdAt).format('DD.MM.YYYY HH:mm')}
                                </span>
                            </div>
                            <div className="w-[20%] flex items-center justify-center">
                                <span className="text-[16px] font-[400] text-black">
                                    {moment(item.attendanceDatetime).format('DD.MM.YYYY HH:mm')}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
